import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/mockData';
import PostCard from '../../components/PostCard';
import './index.css';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [popularPosts, setPopularPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('all');
  const [catMood, setCatMood] = useState('😺');

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      
      // 获取分类
      const categoriesResponse = await api.getCategories();
      if (categoriesResponse.success) {
        setCategories(categoriesResponse.data);
      }

      // 获取文章
      const postsResponse = await api.getPosts({ 
        sort: 'latest',
        limit: 12
      });

      if (postsResponse.success) {
        // 可靠的图片链接列表
        const reliableImages = [
          'https://images.unsplash.com/photo-1514888286974-6d03bde4ba48?w=800&h=400&fit=crop',
          'https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=800&h=400&fit=crop',
          'https://images.unsplash.com/photo-1533743983669-94fa5c4338ec?w=800&h=400&fit=crop',
          'https://images.unsplash.com/photo-1543852786-1cf6624b9987?w=800&h=400&fit=crop',
          'https://images.unsplash.com/photo-1531048563740-c9c55a0dc4fa?w=800&h=400&fit=crop'
        ];
        
        const allPosts = postsResponse.data.map((post, index) => {
          // 确保图片链接有效
          const hasValidImage = post.coverImage && 
            (post.coverImage.includes('unsplash.com') || 
             post.coverImage.includes('pexels.com') ||
             post.coverImage.includes('pixabay.com'));
          
          return {
            ...post,
            // 如果原图片无效，使用可靠的备选图片
            coverImage: hasValidImage ? post.coverImage : reliableImages[index % reliableImages.length],
            // 确保 author 对象存在
            author: post.author || {
              id: post.authorId || 1,
              name: post.authorId === 2 ? '猫博士' : '猫咪守护者',
              avatar: post.authorId === 2 
                ? 'https://images.unsplash.com/photo-1519058082700-08a0b56da9b4?w=100&h=100&fit=crop&crop=face'
                : 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=100&h=100&fit=crop&crop=face'
            }
          };
        });
        
        setPosts(allPosts);
        
        // 精选文章
        const featured = allPosts.filter(post => post.featured).slice(0, 3);
        setFeaturedPosts(featured);
        
        // 热门文章
        const popular = [...allPosts]
          .sort((a, b) => (b.likes || 0) - (a.likes || 0))
          .slice(0, 5);
        setPopularPosts(popular);
      }

    } catch (error) {
      console.error('加载数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);

  // 根据分类筛选文章
  const filteredPosts = activeFilter === 'all' 
    ? posts 
    : posts.filter(post => post.category === activeFilter);

  // 获取分类对应的猫咪表情
  const getCatEmoji = (category) => {
    const emojiMap = {
      '日常趣事': '😺',
      '养护知识': '📚',
      '行为解读': '🔍',
      '饮食健康': '🍲',
      '新手指南': '🐱',
      '健康护理': '❤️',
      '猫咪玩具': '🎮',
      '日常护理': '🛁',
      '猫咪品种': '🐈',
      '猫咪训练': '🎯'
    };
    return emojiMap[category] || '🐱';
  };

  // 格式化日期
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}日`;
    } catch (error) {
      return '未知日期';
    }
  };

  // 获取新的猫咪心情
  const getRandomCatMood = () => {
    const moods = ['😺', '😸', '😻', '😽', '🙀', '😿', '😾', '🐱', '🐈', '🐾'];
    return moods[Math.floor(Math.random() * moods.length)];
  };

  if (loading) {
    return (
      <div className="home-loading">
        <div className="loading-cat">
          <div className="cat-emoji">🐱</div>
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className="loading-text">猫咪正在整理文章...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      {/* 猫咪耳朵装饰 */}
      <div className="cat-ears-decoration">
        <div className="cat-ear left-ear"></div>
        <div className="cat-ear right-ear"></div>
      </div>

      {/* 英雄区域 */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                喵星人<span className="highlight">日记</span>
                <span className="cat-emoji-large">🐱</span>
              </h1>
              <p className="hero-subtitle">
                记录与猫咪共度的美好时光，分享养猫心得、趣事和科学知识
              </p>
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">{posts.length}+</span>
                  <span className="stat-label">篇文章</span>
                </div>
                <div className="stat">
                  <span className="stat-number">1200+</span>
                  <span className="stat-label">猫友</span>
                </div>
                <div className="stat">
                  <span className="stat-number">{categories.length}+</span>
                  <span className="stat-label">分类</span>
                </div>
              </div>
              <div className="hero-actions">
                <Link to="/archive" className="btn-primary">
                  <span className="btn-icon">📚</span>
                  浏览全部文章
                </Link>
                <Link to="/write" className="btn-secondary">
                  <span className="btn-icon">✏️</span>
                  写篇文章
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <div className="floating-cat">
                <div className="cat-body">🐱</div>
                <div className="cat-shadow"></div>
              </div>
              <div className="paw-prints">
                <span className="paw">🐾</span>
                <span className="paw">🐾</span>
                <span className="paw">🐾</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 精选文章 */}
      {featuredPosts.length > 0 && (
        <section className="featured-section">
          <div className="section-header">
            <h2 className="section-title">
              <span className="title-icon">⭐</span>
              精选文章
            </h2>
            <p className="section-subtitle">猫咪社区最受欢迎的好文章</p>
          </div>
          
          <div className="featured-grid">
            {featuredPosts.map((post, index) => (
              <div 
                key={post.id} 
                className="featured-card"
                style={{ '--delay': index * 0.1 + 's' }}
              >
                <div className="featured-card-inner">
                  <div className="featured-image">
                    <img 
                      src={post.coverImage || 'https://images.unsplash.com/photo-1543852786-1cf6624b9987'} 
                      alt={post.title}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://images.unsplash.com/photo-1543852786-1cf6624b9987';
                      }}
                    />
                    <div className="featured-badge">
                      <span className="badge-icon">⭐</span>
                      精选
                    </div>
                  </div>
                  <div className="featured-content">
                    <div className="post-category">
                      <span className="category-icon">
                        {getCatEmoji(post.category)}
                      </span>
                      {post.category}
                    </div>
                    <h3 className="featured-title">{post.title}</h3>
                    <p className="featured-excerpt">{post.excerpt}</p>
                    <div className="featured-meta">
                      <div className="author-info">
                        <img 
                          src={post.author?.avatar || 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=100&h=100&fit=crop&crop=face'} 
                          alt={post.author?.name || '作者'}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=100&h=100&fit=crop&crop=face';
                          }}
                        />
                        <span className="author-name">{post.author?.name || '匿名作者'}</span>
                      </div>
                      <div className="post-stats">
                        <span className="stat">
                          <span className="stat-icon">❤️</span>
                          {post.likes || 0}
                        </span>
                        <span className="stat">
                          <span className="stat-icon">💬</span>
                          {post.comments || 0}
                        </span>
                        <span className="stat">
                          <span className="stat-icon">👁️</span>
                          {post.views || 0}
                        </span>
                      </div>
                    </div>
                    <Link to={`/post/${post.id}`} className="read-more">
                      阅读全文
                      <span className="arrow">→</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* 主要内容区域 */}
      <main className="main-content">
        <div className="content-wrapper">
          {/* 左侧文章列表 */}
          <div className="posts-section">
            <div className="section-header with-filter">
              <h2 className="section-title">
                <span className="title-icon">📝</span>
                最新文章
              </h2>
              
              {/* 分类筛选 */}
              <div className="category-filter">
                <button
                  key="all"
                  className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
                  onClick={() => setActiveFilter('all')}
                >
                  <span className="filter-icon">🐱</span>
                  全部
                </button>
                {categories.map(category => (
                  <button
                    key={category.name}  // 使用 category.name 作为 key
                    className={`filter-btn ${activeFilter === category.name ? 'active' : ''}`}
                    onClick={() => setActiveFilter(category.name)}
                  >
                    <span className="filter-icon">
                      {getCatEmoji(category.name)}
                    </span>
                    {category.name}
                    <span className="category-count">{category.count} 篇</span>
                  </button>
                ))}
              </div>
            </div>

            {/* 文章网格 */}
            <div className="posts-grid">
              {filteredPosts.length > 0 ? (
                filteredPosts.map(post => (
                  <PostCard 
                    key={post.id} 
                    post={post}
                    showExcerpt={true}
                    showCategory={true}
                  />
                ))
              ) : (
                <div className="no-posts">
                  <div className="no-posts-cat">😿</div>
                  <h3>暂时没有文章</h3>
                  <p>这个分类还没有内容，去别的分类看看吧！</p>
                </div>
              )}
            </div>
          </div>

          {/* 右侧边栏 */}
          <aside className="sidebar">
            {/* 猫咪状态 */}
            <div className="widget cat-status">
              <div className="widget-header">
                <h3 className="widget-title">
                  <span className="widget-icon">🐱</span>
                  今日猫咪
                </h3>
                <div className="cat-mood">{catMood}</div>
              </div>
              <div className="cat-stats">
                <div className="cat-stat">
                  <div className="stat-value">{posts.length}</div>
                  <div className="stat-label">篇文章</div>
                </div>
                <div className="cat-stat">
                  <div className="stat-value">{categories.length}</div>
                  <div className="stat-label">个分类</div>
                </div>
                <div className="cat-stat">
                  <div className="stat-value">12</div>
                  <div className="stat-label">小时在线</div>
                </div>
              </div>
              <div className="cat-tip">
                <span className="tip-icon">💡</span>
                今日养猫小贴士：记得给猫咪准备新鲜的水！
              </div>
            </div>

            {/* 热门文章 */}
            <div className="widget popular-posts">
              <div className="widget-header">
                <h3 className="widget-title">
                  <span className="widget-icon">🔥</span>
                  热门文章
                </h3>
              </div>
              <div className="popular-list">
                {popularPosts.slice(0, 5).map((post, index) => (
                  <Link 
                    key={post.id} 
                    to={`/post/${post.id}`}
                    className="popular-item"
                  >
                    <div className="popular-rank">
                      <span className="rank-number">{index + 1}</span>
                    </div>
                    <div className="popular-content">
                      <h4 className="popular-title">{post.title}</h4>
                      <div className="popular-meta">
                        <span className="meta-item">
                          <span className="meta-icon">❤️</span>
                          {post.likes || 0}
                        </span>
                        <span className="meta-item">
                          <span className="meta-icon">👁️</span>
                          {post.views || 0}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* 分类 */}
            <div className="widget categories">
              <div className="widget-header">
                <h3 className="widget-title">
                  <span className="widget-icon">🏷️</span>
                  文章分类
                </h3>
              </div>
              <div className="categories-list">
                {categories.map(category => (
                  <Link 
                    key={category.name}  // 使用 category.name 作为 key
                    to={`/archive?category=${category.name}`}
                    className="category-item"
                  >
                    <div className="category-icon">
                      {getCatEmoji(category.name)}
                    </div>
                    <div className="category-info">
                      <span className="category-name">{category.name}</span>
                      <span className="category-count">{category.count} 篇</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* 猫咪知识小卡片 */}
            <div className="widget cat-fact">
              <div className="widget-header">
                <h3 className="widget-title">
                  <span className="widget-icon">📖</span>
                  猫咪冷知识
                </h3>
              </div>
              <div className="fact-content">
                <div className="fact-cat">😺</div>
                <p className="fact-text">
                  猫咪的耳朵可以旋转180度，每只耳朵由32块肌肉控制！
                </p>
                <button 
                  className="refresh-fact"
                  onClick={() => setCatMood(getRandomCatMood())}
                >
                  <span className="refresh-icon">🔄</span>
                  换一条
                </button>
              </div>
            </div>

            {/* 社区动态 */}
            <div className="widget community">
              <div className="widget-header">
                <h3 className="widget-title">
                  <span className="widget-icon">👥</span>
                  社区动态
                </h3>
              </div>
              <div className="community-activity">
                <div className="activity-item">
                  <div className="activity-avatar">🐱</div>
                  <div className="activity-content">
                    <p><strong>喵小咪</strong> 发布了新文章</p>
                    <span className="activity-time">2小时前</span>
                  </div>
                </div>
                <div className="activity-item">
                  <div className="activity-avatar">😸</div>
                  <div className="activity-content">
                    <p><strong>橘猫家长</strong> 点赞了文章</p>
                    <span className="activity-time">4小时前</span>
                  </div>
                </div>
                <div className="activity-item">
                  <div className="activity-avatar">😻</div>
                  <div className="activity-content">
                    <p><strong>猫博士</strong> 发表了评论</p>
                    <span className="activity-time">6小时前</span>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </main>

      {/* 召唤行动区域 */}
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-content">
            <h2 className="cta-title">分享你的猫咪故事</h2>
            <p className="cta-text">
              加入喵星人日记，记录与猫咪的点点滴滴，与其他猫友交流分享
            </p>
            <div className="cta-actions">
              <Link to="/write" className="cta-button primary">
                <span className="button-icon">✏️</span>
                开始写作
              </Link>
              <Link to="/about" className="cta-button secondary">
                <span className="button-icon">🐱</span>
                了解更多
              </Link>
            </div>
          </div>
          <div className="cta-image">
            <div className="cta-cats">
              <div className="cta-cat cat-1">😺</div>
              <div className="cta-cat cat-2">😸</div>
              <div className="cta-cat cat-3">😻</div>
            </div>
          </div>
        </div>
      </section>

      {/* 页脚装饰 */}
      <div className="home-footer-decoration">
        <div className="running-cats">
          <span className="running-cat">🐱</span>
          <span className="running-cat">🐈</span>
          <span className="running-cat">😺</span>
          <span className="running-cat">😸</span>
        </div>
        <div className="paw-trail">
          {[...Array(20)].map((_, i) => (
            <span key={i} className="paw-print">🐾</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;